import { Component }     from '@angular/core';
import { AppNavigation } from '../../app-navigation';

@Component({
  templateUrl: './home.html'  
})
export class HomeComponent { 

    constructor(public Navigation: AppNavigation) {
      this.Controls = this.Navigation.Items.Values;     
    }
    
    public Controls;
    public Version: string = process.env.Version ? process.env.Version : '';
}



// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/home-component.ts